import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Dotcom2024Service } from '../dotcom2024.service';
import { environment } from '../../environments/environment';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent implements OnInit {

  constructor(private title: Title, private meta: Meta, public dotComService: Dotcom2024Service) {}
  
  baseImagePaths: string = environment.azureBlobStorageURL + environment.baseImagesFilePathBlobStorage + "/";

  firstNameRepMatch: string = "";
  lastNameRepMatch: string = "";
  emailRepMatch: string = "";
  phoneRepMatch: string = "";
  companyRepMatch: string = "";
  titleRepMatch: string = "";
  cityRepMatch: string = "";
  stateRepMatch: string = "";
  zipRepMatch: string = "";
  marketsRepMatch: string = "";
  commentsRepMatch: string = "";
  golfRepMatch: boolean = false;
  lawnCareRepMatch: boolean = false;
  horticultureRepMatch: boolean = false;
  sportsTurfRepMatch: boolean = false;
  specialtyAgRepMatch: boolean = false;


  ngOnInit(): void {
    this.dotComService.activePage = "home";

    //meta tags for SEO
    this.title.setTitle("Harrell’s | Custom Fertilizer & Branded Chemistry Solutions");
    this.meta.updateTag({ name: 'description', content: "Harrell’s provides custom fertilizers and is the largest U.S. distributor of branded chemistry for golf, lawn care, greenhouse, and specialty agriculture." });
    this.meta.updateTag({ property: 'og:title', content: "Harrell’s | Custom Fertilizer & Branded Chemistry Solutions" });
    this.meta.updateTag({ property: 'og:description', content: "Harrell’s provides custom fertilizers and is the largest U.S. distributor of branded chemistry for golf, lawn care, greenhouse, and specialty agriculture." });
    // this.meta.updateTag({ property: 'og:image', content: "og:image here - home" });
    // this.meta.updateTag({ property: 'og:url', content: "og:url here - home" });
    this.meta.updateTag({ property: 'Twitter:card', content: "Harrell’s | Custom Fertilizer & Branded Chemistry Solutions" });
    this.meta.updateTag({ property: 'Twitter:site', content: "Harrell’s | Custom Fertilizer & Branded Chemistry Solutions" });
    this.meta.updateTag({ property: 'Twitter:title', content: "Harrell’s | Custom Fertilizer & Branded Chemistry Solutions" });
    this.meta.updateTag({ property: 'Twitter:description', content: "Harrell’s provides custom fertilizers and is the largest U.S. distributor of branded chemistry for golf, lawn care, greenhouse, and specialty agriculture." });
    // this.meta.updateTag({ property: 'Twitter:image', content: "twitter:image here - home" });
    // this.meta.updateTag({ name: 'author', content: "author tag here - home" });
  }

  ngAfterViewInit() {
    //this keeps the div on the right side the same height as the left side
    var leftDivHeight = document.getElementById('letsGrowTogether').offsetHeight;
            document.getElementById('letsGrowRightPic').style.height = leftDivHeight + 'px';
  }

  OpenhowItWorksModal() {
    //height and width of modal must be 40px larger than video to get that border
    //tht is why the css for the modal is 840x540px when the video tag itself is 800x500
    document.getElementById("howItWorksModal").style.display = "block";
    (<HTMLVideoElement>document.getElementById('howItWorksVideo')).play();
  }

  ClosehowItWorksModal() {
    (<HTMLVideoElement>document.getElementById('howItWorksVideo')).pause();
    document.getElementById("howItWorksModal").style.display = "none";
  }
  
  OpenCoreValuesModal() {
    //height and width of modal must be 40px larger than video to get that border
    //tht is why the css for the modal is 840x540px when the video tag itself is 800x500
    document.getElementById("coreValuesModal").style.display = "block";
    (<HTMLVideoElement>document.getElementById('coreValuesVideo')).play();
  }

  CloseCoreValuesModal() {
    (<HTMLVideoElement>document.getElementById('coreValuesVideo')).pause();
    document.getElementById("coreValuesModal").style.display = "none";
  }

  OpenOurWhyModal() {
    //height and width of modal must be 40px larger than video to get that border
    //tht is why the css for the modal is 840x540px when the video tag itself is 800x500
    document.getElementById("ourWhyModal").style.display = "block";
    (<HTMLVideoElement>document.getElementById('ourWhyVideo')).play();
  }

  CloseOurWhyModal() {
    (<HTMLVideoElement>document.getElementById('ourWhyVideo')).pause();
    document.getElementById("ourWhyModal").style.display = "none";
  }

  OpenCelebrationModal() {
    //height and width of modal must be 40px larger than video to get that border
    //tht is why the css for the modal is 840x540px when the video tag itself is 800x500
    document.getElementById("celebrationModal").style.display = "block";
    (<HTMLVideoElement>document.getElementById('celebrationVideo')).play();
  }

  CloseCelebrationModal() {
    (<HTMLVideoElement>document.getElementById('celebrationVideo')).pause();
    document.getElementById("celebrationModal").style.display = "none";
  }

  sendEmail() {
    const recipient = 'contact@harrells.com';
    const subject = "Harrell's - I'm Ready To Become A Customer!";
    const body = "Hello, I'm Ready To Become A Customer. \n \n " +  
    "First Name: " + this.firstNameRepMatch + " \n " +
    "Last Name: " + this.lastNameRepMatch + " \n " +
    "Company: " + this.companyRepMatch + " \n " +
    "Job Title: " + this.titleRepMatch + " \n \n " +
    "Email: " + this.emailRepMatch + " \n " +
    "Phone: " + this.phoneRepMatch + " \n " +
    "City: " + this.cityRepMatch + " \n " +
    "State: " + this.stateRepMatch + " \n " +
    "Zip: " + this.zipRepMatch + " \n " +
    "Golf: " + this.golfRepMatch.toString().replace('false','').replace('true','Yes') + " \n " +
    "Horticulture: " + this.horticultureRepMatch.toString().replace('false','').replace('true','Yes') + " \n " +
    "SportsTurf: " + this.sportsTurfRepMatch.toString().replace('false','').replace('true','Yes') + " \n " +
    "SpecialtyAg: " + this.specialtyAgRepMatch.toString().replace('false','').replace('true','Yes') + " \n " +
    "LawnCare: " + this.lawnCareRepMatch.toString().replace('false','').replace('true','Yes') + " \n \n " +
    "Comments: " + this.commentsRepMatch + " \n " 

    const mailtoUrl = `mailto:${recipient}?subject=${subject}&body=${encodeURIComponent(body)}`;

    window.location.href = mailtoUrl;

  }

}
